// extracted by mini-css-extract-plugin
export default {"thanksCurrencyIcon":"cLyb4dlUMuerwzbpHNpD"};